import { ApiCustomer } from '../../shared/types/Customer';
import { ApiUser } from '../../shared/types/User';

export const shouldLogAudioDiagnostics = (
  user: ApiUser | undefined,
  activeCustomer: ApiCustomer | undefined,
): boolean => {
  return (
    user?.properties?.enableAudioDiagnostics === 'true' ||
    activeCustomer?.properties?.enableAudioDiagnostics === 'true'
  );
};
